var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { FIT_DATA_TYPE_META, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import ListWithCatalogue from "../ListWithCatalogue/index";
import FloatPortal from '../Portal/FloatPortal';
import CompSource from "../../CompSource";
import DEFAULT_COMPONENT_ICON from '../../assets/defaultComponentIcon.png';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { getFitDataLayout } from "../../../lib/utils";
import AlternativeForCompPopover from './AlternativeForCompPopover';
let AlternativeForDataSourcePopover = class AlternativeForDataSourcePopover extends Vue {
  constructor() {
    super(...arguments);
    this.filterKey = '';
    this.manualSwitch = false;
    /** 是否取消左侧锚点索引 */
    this.hideCatalogue = true;
  }
  /** 对于数据源面板调用的Alternative 期望上这个computed永远不会被计算   */
  get fitDataAll() {
    return this.uc.fitData(this.dataPath, undefined, {
      compTypeFilter: 'all'
    });
  }
  get fitDataResult() {
    if (this.fitData) {
      return this.fitData();
    }
    // 左侧面板的组件推荐面板 推荐时筛选全部组件 如果没有上级缓存就拉fitDataAll算一次
    return (this.fitDataResultTemped || this.fitDataAll).map(x => {
      var _FIT_DATA_TYPE_META$x;
      return {
        ...x,
        typeCName: ((_FIT_DATA_TYPE_META$x = FIT_DATA_TYPE_META[x.type]) === null || _FIT_DATA_TYPE_META$x === void 0 ? void 0 : _FIT_DATA_TYPE_META$x.name) || x.type
      };
    });
  }
  matchAlternateItem(key, item) {
    const k = key.toLowerCase();
    const {
      layout
    } = getFitDataLayout(item);
    return [item.name, item.desc, layout.type].join('\n').toLowerCase().includes(k);
  }
  get itemScopedSlot() {
    const h = this.$createElement;
    return props => {
      var _this$MaterialBox;
      const item = props.item;
      const index = props.index;
      const {
        layout,
        layouts
      } = getFitDataLayout(item);
      const designerDragSource = {
        layout,
        dataPath: this.dataPath
      };
      const extraProps = {};
      if (layouts.length) extraProps.layouts = layouts;
      const handleCompMouseEnter = item => {
        if (!layouts.length || !this.MaterialBox) return;
        if (this.manualSwitch) return;
        clearTimeout(this.timeoutClose);
        this.MaterialBox.currentHoveringComp = {
          item,
          dataPath: this.dataPath
        };
        this.MaterialBox.currentHoveringDataPath = this.dataPath;
      };
      const handleCompMouseLeave = () => {
        if (!layouts.length || !this.MaterialBox) return;
        if (this.manualSwitch) return;
        this.MaterialBox.currentHoveringComp = null;
        this.timeoutClose = setTimeout(() => {
          this.MaterialBox.currentHoveringDataPath = '';
        }, 500);
      };
      const handleClickComp = item => {
        if (!layouts.length || !this.MaterialBox) return;
        this.manualSwitch = !!this.MaterialBox.currentHoveringComp;
        if (this.MaterialBox.currentHoveringComp) this.MaterialBox.currentHoveringComp = null;else {
          this.MaterialBox.currentHoveringComp = {
            item,
            dataPath: this.dataPath
          };
        }
      };
      const hoverCompPopover = item === ((_this$MaterialBox = this.MaterialBox) === null || _this$MaterialBox === void 0 || (_this$MaterialBox = _this$MaterialBox.currentHoveringComp) === null || _this$MaterialBox === void 0 ? void 0 : _this$MaterialBox.item) ? h(AlternativeForCompPopover, {
        "attrs": {
          "dataPath": this.dataPath,
          "value": item,
          "defaultLayout": layout,
          "dragTitle": item.name,
          "dragSource": designerDragSource
        },
        "on": {
          "mouseenter": () => handleCompMouseEnter(item),
          "mouseleave": handleCompMouseLeave,
          "dragstart": () => this.handleDragStart(item),
          "dragend": () => this.handleDragEnd(item)
        }
      }) : null;
      return h(CompSource, {
        "attrs": {
          "value": layout,
          "dragSource": designerDragSource,
          "title": item.name,
          "dragTitle": item.name,
          "fitDataResult": item
        },
        "on": {
          "dragstart": () => this.handleDragStart(item),
          "dragend": () => this.handleDragEnd(item),
          "mouseenter": () => handleCompMouseEnter(item),
          "mouseleave": () => this.MaterialBox.currentHoveringComp = null,
          "click": () => handleClickComp(item)
        }
      }, [h("div", {
        "key": index,
        "class": "ucd-settleComponent-item",
        "attrs": {
          "title": item.name
        }
      }, [h("img", {
        "attrs": {
          "src": item.icon || DEFAULT_COMPONENT_ICON
        },
        "class": "ucd-settleComponent-itemIcon"
      }), h("div", {
        "class": "ucd-settleComponent-itemTitle"
      }, [item.name, item.subTitle && h("span", {
        "class": 'ucd-settleComponent-subTitle'
      }, [item.subTitle])]), layouts !== null && layouts !== void 0 && layouts.length ? h("div", {
        "style": {
          position: 'sticky'
        }
      }, [h("a-icon", {
        "attrs": {
          "type": "caret-right"
        }
      })]) : null, hoverCompPopover])]);
    };
  }
  handleMouseEnter() {
    this.MaterialBox.currentHoveringDataPath = this.dataPath;
    this.MaterialBox.currentHoveringComp = null;
  }
  handleMouseLeave() {
    this.MaterialBox.currentHoveringComp = null;
    this.MaterialBox.currentHoveringDataPath = '';
  }
  handleDragStart(item) {
    const {
      editZoneState
    } = this.uc.designer;
    editZoneState.currentDraggingFitDataResult = item;
  }
  handleDragEnd(item) {
    setTimeout(() => {
      const {
        editZoneState
      } = this.uc.designer;
      if (editZoneState.currentDraggingFitDataResult === item) {
        editZoneState.currentDraggingFitDataResult = void 0;
        this.handleMouseLeave();
      }
    }, 500);
  }
  get isDesignerDragging() {
    // 绑定&拖出组件时，不要显示备选列表
    const {
      currentOperation
    } = this.designer;
    return currentOperation === 'binding' || currentOperation === 'dragging';
  }
  render() {
    var _this$MaterialBox$cur;
    const h = arguments[0];
    const {
      fitDataResult
    } = this;
    if (!(fitDataResult !== null && fitDataResult !== void 0 && fitDataResult.length)) return null;
    return h(FloatPortal, [h("div", {
      "class": mergeClassName('ucd-dataTreeNode-components', this.hideCatalogue && 'ucd-dataTreeNode-components-hideCatalogue', this.isDesignerDragging && 'ucd-dataTreeNode-components-hidden', ((_this$MaterialBox$cur = this.MaterialBox.currentHoveringComp) === null || _this$MaterialBox$cur === void 0 ? void 0 : _this$MaterialBox$cur.dataPath) === this.dataPath && 'ucd-dataTreeNode-components-hover'),
      "on": {
        "mouseenter": this.handleMouseEnter,
        "mouseleave": this.handleMouseLeave
      }
    }, [h(ListWithCatalogue, {
      "class": "ucd-settleComponent-list",
      "attrs": {
        "data": fitDataResult,
        "category-key": "typeCName",
        "filter-key": this.filterKey,
        "filter-function": this.matchAlternateItem,
        "hide-catalogue": this.hideCatalogue
      },
      "scopedSlots": {
        item: this.itemScopedSlot
      }
    })])]);
  }
};
AlternativeForDataSourcePopover = __decorate([Component({
  name: 'AlternativeForDataSourcePopover',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    },
    MaterialBox: {
      from: 'MaterialBox'
    }
  },
  props: {
    dataPath: String,
    fitData: {
      required: false
    },
    fitDataResultTemped: {
      required: false
    }
  }
})], AlternativeForDataSourcePopover);
export default AlternativeForDataSourcePopover;
//# sourceMappingURL=AlternativeForDataSourcePopover.js.map
